// extracted by mini-css-extract-plugin
export default {"container":"bThYMf","title":"BDlbx_"};